const state = {
  snackbarMessage: '',
  snackbarTrigger: false,
  snackbarType: '',
};

const actions = {
  updateMessage({ commit }, message) {
    commit('SET_SNACKBAR_MESSAGE', message);
  },
  updateTrigger({ commit }, value) {
    commit('SET_SNACKBAR_TRIGGER', value);
  },
  showSnackbarWithMessage({ commit }, { message, type }) {
    commit('SET_SNACKBAR_MESSAGE', message);
    commit('SET_SNACKBAR_TYPE', type);
    commit('SET_SNACKBAR_TRIGGER', true);
  },
};

const mutations = {
  SET_SNACKBAR_MESSAGE(state, message) {
    state.snackbarMessage = message;
  },
  SET_SNACKBAR_TRIGGER(state, value) {
    state.snackbarTrigger = value;
  },
  SET_SNACKBAR_TYPE(state, value) {
    state.snackbarType = value;
  },
};

export default {
  state,
  actions,
  mutations,
  namespaced: true,
};
